/**
 * Generates an array of price ranges based on the given maximum price and number of desired ranges.
 *
 * @param {number} maxPrice - The maximum price to be divided into ranges.
 * @param {number} numberOfRanges - The number of price ranges to generate.
 * @returns {Array<{from: string, to: string}>} An array of price range objects with `from` and `to` values as strings.
 *
 * @example
 * generatePriceRanges(100, 4);
 * // Returns:
 * // [
 * //   { from: "0.00", to: "25.00" },
 * //   { from: "25.00", to: "50.00" },
 * //   { from: "50.00", to: "75.00" },
 * //   { from: "75.00", to: "100.00" }
 * // ]
 */
function generatePriceRanges(maxPrice, numberOfRanges) {
    const ranges = [];
    const step = maxPrice / numberOfRanges;
  
    for (let i = 0; i < numberOfRanges; i++) {
        const from = (step * i).toFixed(2);
        const to = (step * (i + 1)).toFixed(2);
        ranges.push({
            from,
            to,
        });
    }
  
    return ranges;
}

export default generatePriceRanges;